import { useMutation } from '@tanstack/react-query';
import type {
	LWApiPublicAccountActivityCreateParamsRaw,
	LWApiPublicAccountActivityCreateResultRaw,
} from '@liquidweb-dev/club-sauce/public/account/activity/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { useMasquerade } from 'modules/oidc/useAuthenticated';
import api from 'modules/queries/api';

const useActivityCreate = () => {
	const isMasquerade = useMasquerade();

	return useMutation<
		LWApiPublicAccountActivityCreateResultRaw,
		ApiErrorI,
		LWApiPublicAccountActivityCreateParamsRaw
	>({
		mutationFn: (params) => {
			// Prevent masquerade activity
			if (isMasquerade) return Promise.resolve({ success: 0 });

			return api.account.activity.apiRaw.create(params);
		},
	});
};

export default useActivityCreate;
